import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "aria-labelledby"]
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    viewBox: { default: "0 0 24 24" },
    width: { default: 24 },
    height: { default: 24 },
    iconName: {},
    iconColor: { default: "currentColor" }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass('icon-' + _ctx.iconName),
    width: _ctx.width,
    height: _ctx.height,
    viewBox: _ctx.viewBox,
    "aria-labelledby": _ctx.iconName,
    role: "presentation"
  }, [
    _createElementVNode("g", { fill: _ctx.iconColor }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})